import Cookies from "universal-cookie";
const cookies = new Cookies();
export const compactNumber = (value) => {
  if (value >= 1000) {
    const suffixes = ["", "k", "m", "b", "t"];
    const suffixNum = Math.floor(("" + value).length / 3);
    let shortValue = parseFloat(
      (suffixNum != 0 ? value / Math.pow(1000, suffixNum) : value).toPrecision(
        2
      )
    );
    if (shortValue % 1 != 0) {
      shortValue = shortValue.toFixed(1);
    }
    return shortValue + suffixes[suffixNum];
  } else {
    return value;
  }
};

export const logout = () => {
  cookies.remove("wmtoken", { domain: ".spiralbound.in", path: "/" });
  cookies.remove("wmusers", { domain: ".spiralbound.in", path: "/" });

  cookies.remove("wmtoken", { path: "/" });
  cookies.remove("wmusers", { path: "/" });
};

export const wordCountFun = (words, limit) => {
  var isCountExced = false;
  // console.log(words, limit,isCountExced)
  if (words.length >= limit) {
    isCountExced = true;
  }
  if (words.length < limit) {
    isCountExced = false;
  }
  return isCountExced;
};

export const internalRedirectionOnLogin = (slug) => {
  window.location.assign(`/${slug}`);
};

export const takeMeToLoginPage = () => {
  logout();
  window.location.assign(`/login`);
};
